import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { EventSliceState, LngLatCoordinatePair } from "./types"

const initialState: EventSliceState = {
    tracking: {
        click: [] as LngLatCoordinatePair[],
    },
}

export const slice = createSlice({
    name: "map/event",
    initialState,
    reducers: {
        clickedPoint(state: EventSliceState, action: PayloadAction<LngLatCoordinatePair>) {
            state.tracking.click.push(action.payload)
        },
    },
})

const { reducer } = slice

export default reducer
